import React from 'react';

const FieldLabel = ({ children, isRequired, style }) => (
  <label style={{
    fontSize: '0.867143em',
    lineHeight: '1.33333',
    color: 'rgb(107, 119, 140)',
    fontWeight: 600,
    display: 'inline-block',
    marginTop: '0px',
    ...style
  }}>
    {children} {isRequired ? <span style={{ color: 'rgb(222, 53, 11)' }}>*</span> : null}
  </label>
);

export default FieldLabel;
